export class ForgotPasswordModel {

    constructor(
      public email: string
    ) {  }
  
  }